import { LocalDateTime } from '@/utils/dates'
import { AxiosInstance } from 'axios'
import { UserType } from '@/utils/userTypes'
import { CiviliteType, PaymentZone } from '@/types'
import axiosInstance from '../index'

export interface ExternalUserInfo {
  type: UserType
  civilite?: string
  businessReason?: string
  firstName: string
  lastName: string
  contactName?: string
  address: string
  complementAddress: string
  zip: string
  town: string
  country: string
  phone: string
  email: string
  paymentZone: PaymentZone
  accountOwner?: string
  iban?: string
  bic?: string
  accountNumber?: string
  bankIdentifier?: string
  bankAddress?: string
  clientId: string
  lastChangeKeyTime: LocalDateTime
  withoutVat?: boolean
  vatNumber?: string
  frfNumber?: string
  internalUser?: boolean
}

export interface Entity {
  id: number,
  type: UserType
  businessReason?: string
  firstName: string
  lastName: string
  civilite: CiviliteType
  bankingInformation: {
    paymentZoneSuggestion?: PaymentZone
    accountOwnerSuggestion?: string
    ibanSuggestion?: string
    bicSuggestion?: string
    accountNumberSuggestion?: string
    bankIdentifierSuggestion?: string
    bankAddressSuggestion?: string
  }
  accountantInformation: {
    isWithoutVatSuggestion?: boolean
    vatNumberSuggestion?: string
    frfNumberSuggestion?: string
  }
  customerId?: number
}

export interface RegisterForm extends Omit<ExternalUserInfo, 'clientId' | 'lastChangeKeyTime'>{
    password: string,
}

class RegisterApi {
    private axios: AxiosInstance

    constructor(axios: AxiosInstance) {
      this.axios = axios
    }

    public async register(form: RegisterForm) {
      await this.axios.post('/register', { ...form })
    }
}

export const registerApi = new RegisterApi(axiosInstance)
